import { render, staticRenderFns } from "./advertoauth-operate.vue?vue&type=template&id=7ed924b6&"
import script from "./advertoauth-operate.vue?vue&type=script&lang=js&"
export * from "./advertoauth-operate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports